import { useQuery } from '@apollo/client/react';

import { getDocumentParserVersionQuery } from '../../services/DocumentService';

export const useDocumentParserVersion = (documentId) => {
  const { data, loading, error } = useQuery(getDocumentParserVersionQuery, {
    fetchPolicy: 'cache-and-network',
    skip: !documentId,
    variables: { id: documentId }
  });

  return { parserVersion: data?.documentParserVersion || null, loading, error };
};
